import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.messaging.conversations;

const getConversations = createSelector(
  getData,
  conversations => conversations
);

export default getConversations;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getConversations.js